import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0.829304 0.0601501C0.553161 0.0601501 0.329304 0.284008 0.329304 0.56015V10.8594C0.329304 11.1356 0.553161 11.3594 0.829304 11.3594H3.46475C3.7409 11.3594 3.96475 11.1356 3.96475 10.8594V0.56015C3.96475 0.284008 3.7409 0.0601501 3.46475 0.0601501H0.829304ZM0.0790901 13.1898C0.0790901 12.7756 0.414877 12.4398 0.82909 12.4398H13.25C13.6642 12.4398 14 12.7756 14 13.1898C14 13.6041 13.6642 13.9398 13.25 13.9398H0.82909C0.414877 13.9398 0.0790901 13.6041 0.0790901 13.1898ZM5.22188 5.75339C5.22188 5.47725 5.44574 5.25339 5.72188 5.25339H8.35733C8.63347 5.25339 8.85733 5.47725 8.85733 5.75339V10.8592C8.85733 11.1354 8.63347 11.3592 8.35733 11.3592H5.72188C5.44574 11.3592 5.22188 11.1354 5.22188 10.8592V5.75339ZM10.6145 1.48291C10.3383 1.48291 10.1145 1.70677 10.1145 1.98291V10.8593C10.1145 11.1354 10.3383 11.3593 10.6145 11.3593H13.2499C13.5261 11.3593 13.7499 11.1354 13.7499 10.8593V1.98291C13.7499 1.70677 13.5261 1.48291 13.2499 1.48291H10.6145Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }